import { PolicyAddressV2 } from "@hagerty/customer-insurance-gateway-client";

import { InsuranceOpsPolicyAddress } from "../../../types/responses";

export const getMockPolicyAddressInsOps = (
  obj?: Partial<InsuranceOpsPolicyAddress>
): InsuranceOpsPolicyAddress => ({
  Municipality: null,
  Country: "US",
  Township: null,
  Type: null,
  EffectiveDate: null,
  ExpirationDate: null,
  IsDefault: null,
  IsSeasonal: null,
  Id: 1773667,
  LineOne: "44900 HGHWY 169 N #103",
  LineTwo: "",
  City: "Wolfforth",
  County: "Lubbock",
  StateRegion: "TX",
  PostalCode: "79382-4315",
  ...obj,
});

export const getMockPolicyAddressCig = (
  obj?: Partial<PolicyAddressV2>
): PolicyAddressV2 => ({
  lineOne: "44900 HGHWY 169 N #103",
  lineTwo: "",
  city: "Wolfforth",
  county: "Lubbock",
  stateRegion: "TX",
  postalCode: "79382-4315",
  country: "US",
  ...obj,
});
